import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Swords } from "lucide-react";
import { toast } from "sonner";

const WEAPONS = [["fioretto", "Fioretto"], ["spada", "Spada"], ["sciabola", "Sciabola"]];

export default function BulkWeaponDialog({ selectedIds, onDone }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("spada");
  const [role, setRole] = useState("primary");
  const [mode, setMode] = useState("add");
  const [busy, setBusy] = useState(false);
  const n = selectedIds.length;

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/athletes/bulk/set-weapon", { ids: selectedIds, weapon_code: code, role, mode });
      toast.success(`${data.updated} atleti: ${WEAPONS.find((w) => w[0] === code)[1]} ${role === "primary" ? "primaria" : "secondaria"}${mode === "replace" ? " (armi precedenti chiuse)" : ""}`);
      setOpen(false); onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
    finally { setBusy(false); }
  };

  const Opt = ({ v, cur, set, children, testId }) => (
    <button type="button" data-testid={testId} onClick={() => set(v)} className={`px-3 py-1.5 text-sm rounded border ${cur === v ? "bg-black text-white border-black" : "border-zinc-200 hover:bg-zinc-50"}`}>{children}</button>
  );

  return (
    <>
      <Button size="sm" variant="secondary" data-testid="bulk-weapon" onClick={() => setOpen(true)}><Swords className="w-3.5 h-3.5 mr-1" />Assegna arma</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Assegna arma a {n} atleti</DialogTitle>
            <DialogDescription>L'arma viene registrata in athlete_weapons (fonte autorevole). Nessuna arma viene mai assegnata automaticamente.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div><div className="text-xs uppercase tracking-wider text-zinc-500 mb-1">Arma</div><div className="flex gap-2">{WEAPONS.map(([v, l]) => <Opt key={v} v={v} cur={code} set={setCode} testId={`bulk-weapon-${v}`}>{l}</Opt>)}</div></div>
            <div><div className="text-xs uppercase tracking-wider text-zinc-500 mb-1">Ruolo</div><div className="flex gap-2"><Opt v="primary" cur={role} set={setRole} testId="bulk-weapon-primary">Primaria</Opt><Opt v="secondary" cur={role} set={setRole} testId="bulk-weapon-secondary">Secondaria</Opt></div></div>
            <div>
              <div className="text-xs uppercase tracking-wider text-zinc-500 mb-1">Armi già attive</div>
              <div className="flex gap-2"><Opt v="add" cur={mode} set={setMode} testId="bulk-weapon-add">Aggiungi (mantieni le altre)</Opt><Opt v="replace" cur={mode} set={setMode} testId="bulk-weapon-replace">Sostituisci</Opt></div>
              <p className="text-xs text-zinc-500 mt-1">{mode === "add" ? "Le armi esistenti restano; se scegli Primaria, diventa la nuova primaria." : "Le altre armi attive passano a \"conclusa\" (storico conservato)."}</p>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
            <Button data-testid="bulk-weapon-confirm" onClick={submit} disabled={busy} className="bg-black hover:bg-zinc-800">{busy ? "Salvo…" : `Assegna a ${n}`}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
